import { Component } from '@angular/core';
import { AppState } from '../../../../../app/app.global';
import { App,LoadingController,AlertController} from 'ionic-angular';
import { ProjectFundingDetail } from '../detail/detail';

@Component({
  templateUrl: 'list.html'
})

export class ProjectFundingList {
	items:any=[];
	pageIndex = 0;//页号
	pageNumber = 20;//每页显示多少
  public loading;
	constructor(public global: AppState,public appCtrl: App,
		private loadCtrl:LoadingController,private alertCtrl: AlertController) {
		this.items = [
		  {"title":"项目名称一","number":"192404984","contractFunds":"2999万","fundsArrived":"2000万"},
		  {"title":"项目名称二","number":"192404984","contractFunds":"2999万","fundsArrived":"2000万"},
		  {"title":"项目名称三","number":"192404984","contractFunds":"2999万","fundsArrived":"2000万"},
		];
	}
	openDetail(item){
		this.appCtrl.getRootNav().push(ProjectFundingDetail,item);
	}
  doRefresh(refresher){
  	  setTimeout(() => {
    	 this.pageIndex = 0;
    	 this.items = [];
    	 this.loadData();
    	 refresher.complete();
  	  }, 1000);
  }
	loadMore(){
		this.pageIndex++;
		this.loadData();
	}
	
	loadData(){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		if(this.items!=null&&this.items.length>0){
			this.handleList(this.items);
		}
	  this.loading.dismiss();//加载动画结束
		
	}
	
	handleList(obj:any){
  	if(obj){
  		var length = obj.length;
  		for(var i=0;i<length;i++){
  			this.items.push(obj[i]);
  		}
		}
  	
  }
}


// WEBPACK FOOTER //
// ./src/pages/application/research/profunding/list/list.ts